const map = require('lodash/fp/map');
const memoizer = require('../request-handler/utils/memoizer');


function serviceFactory({ api }) {

  const initializeTx = memoizer()((inputParam, metaData) =>
    api.initializeTx(inputParam, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const generateTxChallenge = memoizer()((orderObj, inputParam, metaData) =>
    api.generateTxChallenge(orderObj, inputParam, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const verifyChallengeResponse = memoizer()((inputParam, metaData) =>
    api.verifyChallengeResponse(inputParam, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const cancelTx = memoizer()((txType, metaData) =>
    api.cancelTx(txType, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  const tradingCancelTx = memoizer()((txType, metaData) =>
      api.tradingCancelTx(txType, metaData).then((response) => {
        if (!response) return null;
        return JSON.stringify(response);
      }).catch((error) => {
        return null;
      })
    );

  const fetchTx = memoizer()((fetchTxReq, metaData) =>
    api.fetchTx(fetchTxReq, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    })
      .catch((error) => {
        return null;
      })
  );

  const fetchWebTx = ((type, metaData) =>
    api.fetchWebTx(type, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    })
      .catch((error) => {
        return null;
      })
  );
  const rejectTx = ((type, metaData) =>
    api.rejectTx(type, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    })
      .catch((error) => {
        return null;
      })
  );

  const txRefresh = (metaData) =>
    api.txRefresh(metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })

  return {
    initializeTx,
    generateTxChallenge,
    verifyChallengeResponse,
    cancelTx,
    tradingCancelTx,
    fetchTx,
    fetchWebTx,
    txRefresh,
    rejectTx
  };

}

module.exports = serviceFactory;
